const strongPasswordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/

export default {
  namespaced: true,

  state: {
    // maxLength: length => val => val ? (val.length < length + 1 || `Lunghezza massima: ${length} caratteri`) : true,
    isRequired: (msg = 'Campo Obbligatorio', key = null) => val => {
      let res
      if (key) val = val[key]
      if (typeof val === 'string') res = val.trim() !== ''
      if (typeof val === 'number') res = val === 0 || !!val
      return res || msg
    },
    isRequiredNumber: (msg = 'Campo Obbligatorio') => val => !!val || msg,
    isStrong: val => strongPasswordRegex.test(val) || 'La password inserita non è abbastanza efficace',
  },

  getters: {
    isValidNumber: (_, __, ___, rootGetters) => number => {
      const prefix = rootGetters['auth/locale'] === 'it' ? '39' : '351'
      const pattern = rootGetters['auth/locale'] === 'it' ? '3\\d{8,9}' : '9\\d{8}'
      return new RegExp(`^(?:\\+${prefix}|00${prefix})?${pattern}$`).test(number)
    },
    isValidCel: (_, getters) => (msg = 'Numero di cellulare non valido') => number => {
      return number ? (getters.isValidNumber(number) || msg) : true
    },

    // isEqual(obj1, obj2) {
    //   // return JSON.stringify(obj1) === JSON.stringify(obj2)
    //   let isEqual = true
    //   const diffs = []
    //   // eslint-disable-next-line prefer-const
    //   for (let [key, val] of Object.entries(obj1)) {
    //     if (val === '') val = null
    //     if (obj2[key] === '') obj2[key] = null
    //     if (obj2[key] !== val) {
    //       isEqual = false
    //       diffs.push({ key, values: { 1: val, 2: obj2[key] } })
    //     }
    //   }
    //   return { isEqual, diffs }
    // },
  },
}
